"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Input = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _Input = _interopRequireDefault(require("@material-ui/core/Input"));
var _styles = require("@material-ui/core/styles");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _opacity = _interopRequireDefault(require("../../theme/colors/opacity"));
var _excluded = ["classes", "dataMetrics"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var styles = function styles(theme) {
  return {
    disabled: {},
    error: {
      background: _opacity["default"].black[4]
    },
    focused: {
      background: _opacity["default"].black[4]
    },
    input: {
      '&$disabled': {
        color: theme.palette.text.disabled
      },
      color: theme.palette.text.primary,
      padding: '0 8px 0 16px'
    },
    root: _objectSpread({}, theme.typography.body1, {
      '&$disabled': {
        background: _opacity["default"].black[8],
        borderRadius: theme.shape.borderRadius / 2
      },
      '&:hover:not($disabled):not($focused):not($error)': {
        background: _opacity["default"].black[8]
      },
      background: _opacity["default"].black[4],
      minHeight: '36px',
      minWidth: '280px'
    }),
    underline: {
      '&$disabled:before': {
        borderBottom: 'none'
      },
      '&$error:after': {
        borderBottomColor: theme.palette.error.dark
      }
    }
  };
};
var defaultProps = {
  classes: {},
  dataMetrics: {
    root: 'fuse_input'
  },
  fullWidth: false,
  inputComponent: 'input',
  multiline: false,
  type: 'text'
};
var Input = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var classes = props.classes,
    dataMetrics = props.dataMetrics,
    other = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var mergedDataMetrics = _objectSpread({}, defaultProps.dataMetrics, {}, dataMetrics);
  return /*#__PURE__*/_react["default"].createElement(_Input["default"], (0, _extends2["default"])({
    classes: {
      disabled: classes.disabled,
      error: classes.error,
      focused: classes.focused,
      input: classes.input,
      root: classes.root
    },
    className: other.readOnly ? classes.readOnly : '',
    "data-metrics": mergedDataMetrics.root,
    ref: ref
  }, other));
});
exports.Input = Input;
Input.defaultProps = defaultProps;
Input.displayName = 'Input';
Input.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * This property helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it here:
   * https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill
   */
  autoComplete: _propTypes["default"].string,
  /**
   * If `true`, the input will be focused during the first mount.
   */
  autoFocus: _propTypes["default"].bool,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](https://v4.mui.com/api/input/#css) for more details.
   */
  classes: _propTypes["default"].object,
  /**
   * The CSS class name of the wrapper element.
   */
  className: _propTypes["default"].string,
  /**
   * Override the data-metrics attributes applied to the component.
   */
  dataMetrics: _propTypes["default"].shape({
    root: _propTypes["default"].string
  }),
  /**
   * The default input value, useful when not controlling the component.
   */
  defaultValue: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  /**
   * If `true`, the input will be disabled.
   */
  disabled: _propTypes["default"].bool,
  /**
   * If `true`, the input will not have an underline.
   */
  disableUnderline: _propTypes["default"].bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: _propTypes["default"].node,
  /**
   * If `true`, the input will indicate an error. This is normally obtained via context from
   * FormControl.
   */
  error: _propTypes["default"].bool,
  /**
   * If `true`, the input will take up the full width of its container.
   */
  fullWidth: _propTypes["default"].bool,
  /**
   * The id of the `input` element.
   */
  id: _propTypes["default"].string,
  /**
   * The component used for the native input.
   * Either a string to use a DOM element or a component.
   */
  inputComponent: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func, _propTypes["default"].object]),
  /**
   * Attributes applied to the `input` element.
   */
  inputProps: _propTypes["default"].object,
  /**
   * Use that property to pass a ref callback to the native input component.
   */
  inputRef: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object]),
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: _propTypes["default"].oneOf(['dense', 'none']),
  /**
   * If `true`, a textarea element will be rendered.
   */
  multiline: _propTypes["default"].bool,
  /**
   * Name attribute of the `input` element.
   */
  name: _propTypes["default"].string,
  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value`.
   */
  onChange: _propTypes["default"].func,
  /**
   * The short hint displayed in the input before the user enters a value.
   */
  placeholder: _propTypes["default"].string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: _propTypes["default"].bool,
  /**
   * If `true`, the input will be required.
   */
  required: _propTypes["default"].bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  rowsMax: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: _propTypes["default"].node,
  /**
   * Type of the input element. It should be a valid HTML5 input type.
   */
  type: _propTypes["default"].string,
  /**
   * The input value, required for a controlled component.
   */
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].bool, _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].bool]))])
} : {};
var WithStylesInput = (0, _styles.withStyles)(styles)(Input);
WithStylesInput.displayName = 'Input';
var _default = WithStylesInput;
exports["default"] = _default;